"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierSummaryRenewalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../../../commonFunctions");
var TierSummaryRenewalWidget = /** @class */ (function (_super) {
    __extends(TierSummaryRenewalWidget, _super);
    function TierSummaryRenewalWidget(props) {
        return _super.call(this, props) || this;
    }
    TierSummaryRenewalWidget.prototype.render = function () {
        var _this = this;
        var premiumType = this.props.interaction.factors.premiumType;
        var vehicle = this.props.interaction.vehicles[0];
        var tierName = this.getSelectedTierName();
        var tier = (0, commonFunctions_1.getCoverTierWording)(this.props.interaction.coverTier);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "renewal-tier-summary-container", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Comprehensive cover, ", services_1.resourcesHelper.UNDERWRITER, ". All figures include ", premiumType === services_1.PREMIUM_TYPE_ANNUAL ? 'Insurance Premium Tax' : 'Interest and Insurance Premium Tax', "."] }), (0, jsx_runtime_1.jsxs)("div", { className: "renewal-tier-summary-widget w-100 d-flex", children: [(0, jsx_runtime_1.jsx)("div", { className: "mb-4 d-flex justify-content-between ".concat(tierName, "-logo-after"), children: (0, jsx_runtime_1.jsx)("img", { className: "vehicle-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/car-front.svg"), alt: "Vehicle icon" }) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h4", { children: [tier, " Cover"] }), (0, jsx_runtime_1.jsx)("h4", { children: "".concat(vehicle.make, ", ").concat(vehicle.model) }), !vehicle.registrationNumber && (0, jsx_runtime_1.jsx)("p", { className: "text-danger", children: "(no registration number)" }), vehicle.registrationNumber &&
                                    (0, jsx_runtime_1.jsx)("div", { className: "number-plate-preview", children: vehicle.registrationNumber }), (0, jsx_runtime_1.jsx)("div", { id: "edit-car-btn", onClick: function () { return _this.navigateToEditCar(); }, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "edit-car-btn btn btn-primary btn-add", children: "Edit this car" }) }), (0, jsx_runtime_1.jsx)("div", { className: "new-quote-wording", children: "or get a new quote to replace it" }), (0, jsx_runtime_1.jsx)("div", { id: "replace-car-btn", onClick: function () { return _this.navigateToReplaceCar(); }, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "replace-car-btn btn btn-white mb-0 mt-3", children: "Change this car" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex flex-grow-1 justify-content-end", children: (0, jsx_runtime_1.jsx)("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(tierName, ".svg"), alt: "Tier logo", className: "tier-logo" }) })] })] }));
    };
    TierSummaryRenewalWidget.prototype.getSelectedTierName = function () {
        var tierName = "";
        switch (this.props.interaction.coverTier) {
            case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1:
                tierName = "AZ-Bronze";
                break;
            case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2:
                tierName = "AZ-Silver";
                break;
            case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3:
                tierName = "AZ-Gold";
        }
        return tierName;
    };
    TierSummaryRenewalWidget.prototype.navigateToEditCar = function () {
        this.props.engine.navigate("editCarEntryPage", false);
    };
    TierSummaryRenewalWidget.prototype.navigateToReplaceCar = function () {
        this.props.engine.navigate("replaceCarEntryPage", false);
    };
    return TierSummaryRenewalWidget;
}(plugin_journey_1.WidgetBase));
exports.TierSummaryRenewalWidget = TierSummaryRenewalWidget;
//# sourceMappingURL=TierSummaryRenewalWidget.js.map